interface DownloadProps {
  onProgress?: (progress: number) => void
  onSuccess?: () => void
  onError?: (isToastShown: boolean) => void
}

export const useDownloadFile = (props: DownloadProps) => {
  const checkPermission = async () => {
    return true
  }

  const downloadFile = async (url: string, fileName?: string) => {
    return
  }

  return { checkPermission, downloadFile }
}
